import script from "./ProductDataForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductDataForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__